import { combineReducers } from 'redux';
import { watchLiveChannels } from './watchLiveChannels';
import { watchLiveChannelActual } from './watchLiveChannelActual';
export default combineReducers({ watchLiveChannels , watchLiveChannelActual});